"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var SubmissionRecordBase = (0, _immutable.Record)({
  id: null,
  version: null,
  questionId: null,
  questionVersion: null,
  note: '',
  selectedAnswers: (0, _immutable.Set)(),
  submissionId: null
}, 'Submission');

var SubmissionRecord =
/*#__PURE__*/
function (_SubmissionRecordBase) {
  (0, _inherits2.default)(SubmissionRecord, _SubmissionRecordBase);

  function SubmissionRecord() {
    (0, _classCallCheck2.default)(this, SubmissionRecord);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubmissionRecord).apply(this, arguments));
  }

  (0, _createClass2.default)(SubmissionRecord, null, [{
    key: "fromQuestionEntityRecord",
    value: function fromQuestionEntityRecord(question) {
      return new SubmissionRecord({
        questionId: question.questionId,
        questionVersion: question.version,
        note: question.note,
        selectedAnswers: question.selected
      });
    }
  }]);
  return SubmissionRecord;
}(SubmissionRecordBase);

exports.default = SubmissionRecord;
module.exports = exports.default;